export default __webpack_public_path__ + "static/media/question-svgrepo-com.479edf26.svg";